import { useUserInfo } from "@/api/user";
import Sentry from "@/integrations/Sentry";
import { trackSessionStart } from "@/utils/analytics";
import { useEffect, useRef } from "react";

// Mixpanel identity lives in AnalyticsIdentitySync; this keeps GTM + Sentry.
export function useTrackUser() {
  const { data: userInfo } = useUserInfo();
  const hasTrackedSessionStart = useRef(false);

  useEffect(() => {
    if (userInfo) {
      // Track session start only once
      if (!hasTrackedSessionStart.current) {
        trackSessionStart({ userId: userInfo.user.id });
        hasTrackedSessionStart.current = true;
      }

      Sentry.setUser({
        email: userInfo.user.email,
        id: userInfo.user.id,
        organization_id: userInfo.organization?.id,
        organization: userInfo.organization?.name,
      });

      Sentry.setTags({
        user_id: userInfo.user.id,
        user_name: userInfo.user.name,
        user_email: userInfo.user.email,
        organization_id: userInfo.organization?.id,
        organization_name: userInfo.organization?.name,
      });
    }
  }, [userInfo]);
}
